export const GTMEventData = {
  addToCartButtonClick: {
    event: 'track_ecommerce',
    eventCategory: 'add_item',
    eventAction: 'click_button',
    eventLabel: 'add_item | {{Product_SKU}} | {{Product_Name}}',
  },

  checkoutButtonClick: {
    event: 'track_ecommerce',
    eventCategory: 'checkout',
    eventAction: 'click_button',
    eventLabel: 'begin_checkout',
  },

  placeOrderButtonClick: {
    event: 'track_ecommerce',
    eventCategory: 'checkout',
    eventAction: 'click_button',
    eventLabel: 'place_order_click',
  },

  orderPurchaseSuccess: {
    event: 'track_ecommerce',
    eventCategory: 'checkout',
    eventAction: 'purchase',
    eventLabel:
      'purchase_success | {{Order_ID}} | {{Payment_Method}} | {{Shipping_Method}}',
  },
};

export const test = {};
